import { i18nMark } from '@lingui/react'

export const CHECKOUT_STEPS = {
  1: i18nMark('checkout.header.step.name.1'),
  2: i18nMark('checkout.header.step.name.2'),
  3: i18nMark('checkout.header.step.name.3'),
}
